import { Component, OnInit } from '@angular/core';
import { User } from './model/User';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: false
})
export class UsersComponent implements OnInit {

  public selectedUser: User;

  constructor() { }

  ngOnInit(): void {
  }

  userClicked(user: User) {    
    this.selectedUser = user;
  }

}
